module.exports = __webpack_public_path__ + "static/media/fly0038.1e823cf0.webp";